<div class="long-option-single-choice-question">
	<div class="question">
		<span>{{ 'estimate-questions.' + accreditationBody + '.' + question.questionId + '.title' | translate }}</span>
		<change-label [visible]="hasAnswerChanged()" [changeSet]="changeSet"></change-label>
	</div>
	<div class="answer" [innerHTML]="'estimate-questions.' + accreditationBody + '.' + question.chosenOptionIds[0] | translate"></div>

	@for (attachedQuestion of question.attachedQuestions; track attachedQuestion.type) {
		@if (attachedQuestion.questionType == 'RADIO' && attachedQuestion.answer != null) {
			<div class="form-row radio-row with-padding-bottom attached-question">
				<div class="radio-column">
					<nb-radio id="multiSite" [name]="uniqueName()" [checked]="true" status="primary">
						{{ attachedQuestion.answer | booleanDisplay }}
					</nb-radio>
				</div>
				<div class="radio-description-column text-center">
					{{ attachedQuestion.question }}
				</div>
			</div>
		}
		@if (attachedQuestion.questionType == 'TEXT') {
			<div class="attached-question">
				<span style="font-weight: bold;">{{ attachedQuestion.answer }}</span>
			</div>
		}
		@if (translationsHelper.translationExists(standard, getTranslationSubjectFor(question, attachedQuestion), useOriginalTranslations)) {
			<translation-field [standard]="standard" [previewMode]="!translateClientsData"
							   [translatedText]="translationsHelper.getTranslation(standard, getTranslationSubjectFor(question, attachedQuestion), useOriginalTranslations)"
							   [translationSubject]="getTranslationSubjectFor(question, attachedQuestion)"></translation-field>
		}
		@if (attachedQuestion.answer != null) {
			<div class="margin-bottom-20"></div>
		}
	}
</div>
